import React, { useRef, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReactToPrint from "react-to-print";
import ExpandedSencoReportView from "./ExpandedSencoReportView";
import "./PrintClassResults.css";
import ExpandedSENWatchlistView from "./ExpandedSENWatchlistView";
import useAcademicYearOptions from "../utils/useAcademicYearOptions";

function PrintSENWatchlist(props) {
  const [currentAcademicYear] = useAcademicYearOptions({ previousYears: 0 });
  const {
    classDetails,
    classAssessments,
    classid,
    // gradeLevel,
    teachers,
    teacherid,
    assessment,
    assessmentResultsByStudent,
    students,
    studentsReadingScore,
    showAtRiskOnly,
    setShowAtRiskOnly,
    setSortCriteria,
    sortCriteria,
    onSortData,
    showSortedData,
    schoolid,
  } = props;

  const componentRef = useRef();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: landscape;
            }
          }
        `}
      </style>
      <SencoReportPrintable
        ref={componentRef}
        classDetails={classDetails}
        classAssessments={classAssessments}
        classid={classid}
        // gradeLevel={gradeLevel}
        teachers={teachers}
        teacherid={teacherid}
        assessment={assessment}
        assessmentResultsByStudent={assessmentResultsByStudent}
        students={students}
        studentsReadingScore={studentsReadingScore}
        showAtRiskOnly={showAtRiskOnly}
        setShowAtRiskOnly={setShowAtRiskOnly}
        setSortCriteria={setSortCriteria}
        sortCriteria={sortCriteria}
        onSortData={onSortData}
        showSortedData={showSortedData}
        schoolid={schoolid}
        refreshKey={refreshKey}
        academicYear={currentAcademicYear.display}
      />
      <ReactToPrint
        content={() => componentRef.current}
        onBeforeGetContent={() =>
          new Promise((resolve) => {
            setRefreshKey((k) => k + 1);
            setTimeout(resolve, 500);
          })
        }
        trigger={() => <button className="print-button">Print</button>}
      />
    </>
  );
}

const SencoReportPrintable = React.forwardRef((props, ref) => {
  return (
    <div
      className="senco-hide-div senco-landscape-print"
      ref={ref}
      style={{ position: "relative", minHeight: "100vh" }}
    >
      {/* Print-only header */}
      <div className="alpaca-print-header">
        <div className="printout-logo" />
        <div className="alpaca-print-header-text">
          <span className="alpaca-print-header-year">
            School Year: {props.academicYear}
          </span>
        </div>
      </div>
      <Row className="mt-5 text-center">
        <Col className="printout-logo col-2"></Col>
        <Col className="col-4">
          <h3 className="printout-page-description-header">
            {"SEN Watchlist"}
          </h3>
        </Col>
        <Col className="col-4">
          <h3 className="printout-page-description-header">{""}</h3>
        </Col>
        <Col className="col-2">
          <h3 className="printout-page-description-header">
            {new Date().toLocaleString("default", { month: "long" })}{" "}
            {new Date().getFullYear()}
          </h3>
        </Col>
      </Row>
      <Row>
        <ExpandedSENWatchlistView
          students={props.students}
          classDetails={props.classDetails}
          classid={props.classid}
          classAssessments={props.classAssessments}
          //   gradeLevel={props.gradeLevel}
          teachers={props.teachers}
          teacherid={props.teacherid}
          assessment={props.assessment}
          assessmentResultsByStudent={props.assessmentResultsByStudent}
          studentsReadingScore={props.studentsReadingScore}
          showSortedData={props.showSortedData}
          showAtRiskOnly={props.showAtRiskOnly}
          setShowAtRiskOnly={props.setShowAtRiskOnly}
          setSortCriteria={props.setSortCriteria}
          sortCriteria={props.sortCriteria}
          onSortData={props.onSortData}
          schoolid={props.schoolid}
          refreshKey={props.refreshKey}
        />
      </Row>
      {/* <div
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          textAlign: "center",
          fontSize: "0.9rem",
          color: "#888",
          padding: "8px 0",
          background: "white",
          zIndex: 1000,
        }}
      >
        Powered by ALPACA &copy; {new Date().getFullYear()}
      </div> */}
    </div>
  );
});

export default PrintSENWatchlist;
